import { API_BASE_URL } from "@/api/api.config";
import useRestQuery from "@/remoteState/useRestQuery";
import stringifyParams from "@/utils/stringifyParams";

/**
 *
 * @param {string[]} content ids to request
 * @param { depth: number,
 * member_limit: number,
 * shape: ('card'|'outline'),
 * use_imgix: boolean }} request params
 * @returns ContentAPI response
 */

/**
 * @deprecated Use useContentQuery instead.
 */
export const useContent = (contentIds, params = {}, skip = false) => {
  let contentUrl = `${API_BASE_URL}/api/v3/content`;
  if (Array.isArray(contentIds)) {
    // If we receive an array of contentIds, it needs to be added to our parameter list
    // before we stringify it, as the content API expects those to be furnished like
    // ?ids=ckre0behu00013h60110bb6px,ckd4tly7100003dmt4gfi3fw6.
    params = {
      ...params,
      ids: contentIds,
    };
  } else {
    // Otherwise, we can assume we have a singular ID, and pass it as part of the URL
    // path.
    contentUrl = `${contentUrl}/${contentIds}`;
  }
  const queryParamString = stringifyParams(params);
  contentUrl = `${contentUrl}/${queryParamString}`;

  return useRestQuery(contentUrl, { skip });
};

export default useContent;
